import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartguy/src/app/(Guest)/daily-message/[videoId]/components/VideoPage.jsx");
